/**
 * 认证管理器 - 提供全局 clearAuth 访问
 * 用于在 axios 拦截器等非 React 上下文中清除认证状态
 */

type ClearAuthFn = (reason?: string) => void;

let globalClearAuth: ClearAuthFn | null = null;

/**
 * 注册全局 clearAuth 函数（由 AuthContext 调用）
 */
export function registerClearAuth(clearAuthFn: ClearAuthFn) {
  globalClearAuth = clearAuthFn;
}

/**
 * 调用全局 clearAuth 函数
 */
export function clearAuth(reason?: string) {
  if (globalClearAuth) {
    globalClearAuth(reason);
  } else {
    // 不再执行降级处理，避免状态不一致
    // 由 AuthContext 统一管理认证状态
  }
}

/**
 * 检查是否已注册
 */
export function isClearAuthRegistered(): boolean {
  return globalClearAuth !== null;
}
